// ============ PADELO THEME JS ============

// ---- Toast ----
function showToast(msg) {
  var toast = document.getElementById('toast');
  var toastMsg = document.getElementById('toastMsg');
  if (!toast || !toastMsg) return;
  toastMsg.textContent = msg;
  toast.classList.add('show');
  clearTimeout(window._toastTimer);
  window._toastTimer = setTimeout(function () {
    toast.classList.remove('show');
  }, 2600);
}

// ---- Real Shopify Cart AJAX API ----
window.PadeloCart = {
  addToCart: function (variantId, productName) {
    if (!variantId) {
      showToast('This product has no purchasable variant');
      return;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error(err.description || 'Could not add to cart');
          });
        }
        return res.json();
      })
      .then(function () {
        showToast('Added "' + productName + '" to cart');
        PadeloCart.refreshCartCount();
      })
      .catch(function (err) {
        showToast(err.message || 'Something went wrong adding to cart');
      });
  },

  refreshCartCount: function () {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var el = document.querySelector('.cart-count');
        if (el) el.textContent = cart.item_count;
      });
  }
};

// ---- Product page: standard Shopify product form already posts to /cart/add, no JS required ----
// ---- Product page: variant option -> variant id sync (basic, for themes with >1 variant) ----
document.addEventListener('DOMContentLoaded', function () {
  var variantSelects = document.querySelectorAll('.variant-option');
  var hiddenInput = document.getElementById('ProductVariantId');
  if (variantSelects.length && hiddenInput && window.__productVariants) {
    // Optional enhancement point: wire full variant-matching JSON if needed later.
  }

  // ---- Wishlist buttons on collection/grid pages ----
  document.body.addEventListener('click', function (e) {
    var wishBtn = e.target.closest('[data-wish]');
    if (wishBtn) {
      e.preventDefault();
      wishBtn.classList.toggle('active');
      showToast(wishBtn.classList.contains('active') ? 'Saved to wishlist' : 'Removed from wishlist');
    }
  });

  // ---- Hero 3D mouse tilt ----
  (function () {
    var stage = document.querySelector('.racket-stage');
    var wrap = document.querySelector('.racket-img-wrap');
    if (!stage || !wrap) return;
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isTouch = window.matchMedia('(hover: none)').matches;
    if (prefersReduced || isTouch) return;

    stage.addEventListener('mousemove', function (e) {
      var rect = stage.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      wrap.style.animation = 'none';
      wrap.style.transform = 'rotate(-6deg) rotateY(' + (x * 22) + 'deg) rotateX(' + (-y * 16) + 'deg) translateY(' + (y * -8) + 'px)';
    });
    stage.addEventListener('mouseleave', function () {
      wrap.style.transform = '';
      wrap.style.animation = '';
    });
  })();

  // ---- Scroll reveal ----
  var revealTargets = document.querySelectorAll('.t-card, .usp-item');
  if ('IntersectionObserver' in window && revealTargets.length) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    revealTargets.forEach(function (el) {
      el.classList.add('reveal');
      revealObserver.observe(el);
    });
  }

  // ---- Newsletter form toast (form itself submits to Shopify's real customer endpoint) ----
  var newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function () {
      showToast('Thanks for subscribing — check your inbox for your code');
    });
  }

  // ---- Racket quiz ----
  initRacketQuiz();
});

function initRacketQuiz() {
  var quizSection = document.getElementById('quiz');
  if (!quizSection) return;

  var quizAnswers = {};
  var steps = ['1', '2', '3', '4', '5', 'result'];
  var currentStep = 0;

  function goToStep(index) {
    document.querySelectorAll('.quiz-step').forEach(function (s) { s.classList.remove('active'); });
    var target = document.querySelector('.quiz-step[data-step="' + steps[index] + '"]');
    if (target) target.classList.add('active');
    currentStep = index;
    var segs = document.querySelectorAll('#quizProgress .seg');
    segs.forEach(function (seg, i) {
      var fill = seg.querySelector('.fill');
      if (!fill) return;
      fill.style.width = i < index ? '100%' : (i === index ? '50%' : '0%');
    });
  }

  document.querySelectorAll('.quiz-step[data-step]').forEach(function (stepEl) {
    var stepNum = stepEl.dataset.step;
    if (stepNum === 'result') return;
    stepEl.querySelectorAll('.quiz-opt').forEach(function (opt) {
      opt.addEventListener('click', function () {
        stepEl.querySelectorAll('.quiz-opt').forEach(function (o) { o.classList.remove('selected'); });
        opt.classList.add('selected');
        quizAnswers[stepNum] = opt.dataset.value;
        setTimeout(function () {
          if (currentStep < 4) {
            goToStep(currentStep + 1);
          } else {
            computeResult(quizAnswers);
            goToStep(5);
          }
        }, 280);
      });
    });
    var backBtn = stepEl.querySelector('.quiz-back');
    if (backBtn) {
      backBtn.addEventListener('click', function () { goToStep(currentStep - 1); });
    }
  });

  function computeResult(answers) {
    var level = answers['1'] || 'Intermediate';
    var priority = answers['5'] || 'Balance';
    var matches = window.PadeloQuizMatches || {};
    var match;

    if (level === 'Beginner') {
      match = matches.beginner;
    } else if (level === 'Professional' || (level === 'Advanced' && priority === 'Power')) {
      match = matches.power;
    } else if (priority === 'Control') {
      match = matches.control;
    } else if (level === 'Advanced') {
      match = matches.advanced;
    } else {
      match = matches.allround;
    }

    if (!match || !match.name) {
      showToast('Add products to the quiz sections in the theme editor');
      return;
    }

    var nameEl = document.getElementById('resultName');
    var descEl = document.getElementById('resultDesc');
    var priceEl = document.getElementById('resultPrice');
    var imgEl = document.getElementById('resultImg');
    var ctaEl = document.getElementById('addResultToCart');

    if (nameEl) nameEl.textContent = match.name;
    if (descEl) descEl.textContent = match.desc || '';
    if (priceEl) priceEl.textContent = match.price || '';
    if (imgEl) { imgEl.src = match.img || ''; imgEl.alt = match.name; }
    if (ctaEl) ctaEl.href = match.url || '#';
  }

  var retakeBtn = document.getElementById('retakeQuiz');
  if (retakeBtn) {
    retakeBtn.addEventListener('click', function () {
      document.querySelectorAll('.quiz-opt').forEach(function (o) { o.classList.remove('selected'); });
      Object.keys(quizAnswers).forEach(function (k) { delete quizAnswers[k]; });
      goToStep(0);
    });
  }
}
